/* Pill badge primitive. Each tone pairs a pastel fill with its matching
 * `deep` text color from the tailwind `pastel` scale — never plain gray
 * on a pastel fill. Tone strings are self-contained (filled tones carry
 * a transparent border) so every chip renders the same box size.
 */
const BASE = 'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold';

const TONES = {
  peach: 'border border-transparent bg-pastel-peach text-pastel-peach-deep',
  sage: 'border border-transparent bg-pastel-sage text-pastel-sage-deep',
  sky: 'border border-transparent bg-pastel-sky text-pastel-sky-deep',
  lilac: 'border border-transparent bg-pastel-lilac text-pastel-lilac-deep',
  butter: 'border border-transparent bg-pastel-butter text-pastel-butter-deep',
  ink: 'border border-transparent bg-ink text-cream-50',
  outline: 'border border-ink/15 bg-transparent text-ink-600',
};

export default function Chip({ tone = 'peach', icon: Icon, className = '', children, ...props }) {
  const toneClass = typeof TONES[tone] === 'string' ? TONES[tone] : TONES.peach;
  return (
    <span className={`${BASE} ${toneClass} ${className}`} {...props}>
      {Icon && <Icon className="w-3.5 h-3.5" aria-hidden="true" />}
      {children}
    </span>
  );
}
